module.exports = __webpack_public_path__ + "static/media/qr-paytm.85fcfe0a.svg";